import { EditorListing, ListingApiResponse } from 'src/common/types/api/listings';
import apiFetch from 'src/common/utils/apiFetch';

export type ListingFetchResult = {
  success: boolean;
  listingId?: string;
  data?: EditorListing;
};
const callListingFetch = async (
  listingId: string,
  url: string,
  options: RequestInit = {},
): Promise<ListingFetchResult> => {
  try {
    const response = await apiFetch<ListingApiResponse>(url, options);
    if (response.error) {
      return { success: false, listingId };
    }
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, listingId };
  }
};

export default callListingFetch;
